import { resolveResponsiveFactor } from '../../resolvers/ComposedResolvers';
import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolveCircle(theme, screenWidth, circleSupport) {
    var result = {};
    if (circleSupport.size !== undefined) {
        var size = resolveResponsiveFactor(theme, screenWidth, circleSupport.size);
        result.height = size;
        result.width = size;
    }
    if (circleSupport.circle !== undefined) {
        if (resolveResponsiveValue(theme, screenWidth, circleSupport.circle)) {
            result.borderRadius = '50%';
        }
    }
    return result;
}
//# sourceMappingURL=CircleResolver.js.map